module.exports = __webpack_public_path__ + "img/dinesh.8385f541.png";